import React from 'react';
export function Footer() {
  return <footer className="py-16 border-t border-white/10 bg-[#060913]" data-id="element-87">
      <div className="container mx-auto px-4 text-center" data-id="element-88">
        <div className="mb-8" data-id="element-89">
          <h2 className="text-2xl font-display font-bold text-white mb-2 flex items-center justify-center gap-2" data-id="element-90">
            <span aria-hidden="true" data-id="element-91">😴</span> CLOSE THE GAP™
          </h2>
          <p className="text-amber-500 font-medium mb-4" data-id="element-92">
            El sistema de optimización del sueño N°1 para Argentina.
          </p>
          <p className="text-slate-400 max-w-xl mx-auto" data-id="element-93">
            Porque dormir mal no es tu destino — es un problema con solución. Y
            la solución empieza esta noche.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-slate-300 mb-12" data-id="element-94">
          <a href="https://www.recursoclosethegap.shop" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-amber-400 transition-colors" data-id="element-95">
            <span aria-hidden="true" data-id="element-96">🌐</span> www.recursoclosethegap.shop
          </a>
        </div>

        <div className="text-slate-500 text-sm mb-8" data-id="element-97">
          © Close The Gap™ 2024 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </div>

        <div className="inline-block px-6 py-3 rounded-full bg-slate-800/30 border border-white/5 text-slate-300 italic font-medium" data-id="element-98">
          <span aria-hidden="true" data-id="element-99">😴</span> "La mejor noche de tu vida está a
          un protocolo de distancia."
        </div>
      </div>
    </footer>;
}